import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.scss';
import Helmet from 'react-helmet';
import AuthenticationCompleteScreen from './screens/authentication_complete/AuthenticationCompleteScreen';
import MPGSRedirectScreen from './screens/mpgs_redirect/MPGSRedirectScreen';
import MainScreen from './screens/main/MainScreen';

export default class App extends Component {
  render() {
    return (
      <div className="App">
        <Helmet>
          <title>PayMongo</title>
        </Helmet>
        <Router>
          <Switch>
            <Route path="/mpgs_redirect">
              <MPGSRedirectScreen />
            </Route>
            <Route path="/authentication_complete">
              <AuthenticationCompleteScreen />
            </Route>
            <Route path="/">
              <MainScreen />
            </Route>
          </Switch>
        </Router>
      </div>
    );
  }
}
